<template>
  <ContextMenuSub v-if="slots.submenu">
    <ContextMenuSubTrigger
      v-bind="$attrs"
      :disabled="disabled || loading"
      class="data-highlighted:bg-gray-lighten-2 relative flex cursor-pointer flex-wrap items-center justify-between px-2 py-1.5 text-sm outline-none select-none data-disabled:cursor-not-allowed! data-disabled:opacity-30"
      @click.capture="preventWhenLoading"
      @contextmenu.capture="preventWhenLoading"
    >
      <div class="min-w-0 space-x-2" :class="loading ? 'w-full' : 'flex-1'">
        <slot />
      </div>
      <PButton
        v-if="!loading && !disabled"
        variant="ghost"
        title="Submenu weergeven"
        size="sm"
        :icon="['fas', 'chevron-right']"
      />
      <PProgress v-if="loading" size="xs" class="mt-1" aria-label="Menuactie wordt uitgevoerd" />
    </ContextMenuSubTrigger>

    <ContextMenuPortal>
      <ContextMenuSubContent
        class="divide-gray-lighten-2 surface border-gray-lighten-1 z-50 min-w-64 divide-y rounded-md border focus:outline-hidden"
        :collision-padding="4"
        :side-offset="2"
        loop
        @pointerdown.stop
        @touchstart.stop
        @click.stop
        @contextmenu.prevent.stop
      >
        <slot name="submenu" />
      </ContextMenuSubContent>
    </ContextMenuPortal>
  </ContextMenuSub>

  <ContextMenuItem
    v-else
    v-bind="$attrs"
    :disabled="disabled || loading"
    class="data-highlighted:bg-gray-lighten-2 relative flex cursor-pointer flex-col items-start justify-between px-2 py-1.5 text-sm outline-none select-none data-disabled:cursor-not-allowed! data-disabled:opacity-30"
    :class="loading ? 'cursor-wait!' : ''"
    @click.capture="preventWhenLoading"
    @contextmenu.capture="preventWhenLoading"
  >
    <div class="w-full space-x-2">
      <slot />
    </div>
    <PProgress v-if="loading" size="xs" class="mt-1" aria-label="Menuactie wordt uitgevoerd" />
  </ContextMenuItem>
</template>

<script setup lang="ts">
import { useSlots } from "vue"
import {
  ContextMenuItem,
  ContextMenuPortal,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger
} from "reka-ui"
import PProgress from "@/components/elements/PProgress.vue"
import PButton from "@/components/elements/PButton.vue"

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    loading?: boolean
  }>(),
  {
    disabled: false,
    loading: false
  }
)

defineOptions({
  inheritAttrs: false
})

const slots = useSlots()

function preventWhenLoading(event: Event) {
  if (props.loading) {
    event.preventDefault()
    event.stopPropagation()
  }
}
</script>
